import { withIcon } from '@optimizely/axiom-icons';

export const IconToggleOffRegular = withIcon(
  {
    icon: [
      20,
      16,
      [],
      '',
      [
        'M13 3.5H7C4.5 3.5 2.5 5.53125 2.5 8C2.5 10.5 4.5 12.5 7 12.5H13C15.4688 12.5 17.5 10.5 17.5 8C17.5 5.53125 15.4688 3.5 13 3.5ZM19 8C19 11.3125 16.3125 14 13 14H7C3.6875 14 1 11.3125 1 8C1 4.6875 3.6875 2 7 2H13C16.3125 2 19 4.6875 19 8ZM8.5 8C8.5 7.46875 8.1875 7 7.75 6.71875C7.28125 6.4375 6.6875 6.4375 6.25 6.71875C5.78125 7 5.5 7.46875 5.5 8C5.5 8.5625 5.78125 9.03125 6.25 9.3125C6.6875 9.59375 7.28125 9.59375 7.75 9.3125C8.1875 9.03125 8.5 8.5625 8.5 8ZM4 8C4 6.9375 4.5625 5.96875 5.5 5.40625C6.40625 4.875 7.5625 4.875 8.5 5.40625C9.40625 5.96875 10 6.9375 10 8C10 9.09375 9.40625 10.0625 8.5 10.625C7.5625 11.1562 6.40625 11.1562 5.5 10.625C4.5625 10.0625 4 9.09375 4 8Z',
      ],
    ],
    iconName: 'toggle-off-regular',
    prefix: 'ax',
  },
  'IconToggleOffRegular'
);
